/*
 * Copyright (c) 2023 Limpide
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the "Software"), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import Base from '@scripts/components/base'

export default class Banner extends Base {
    toggle?: HTMLButtonElement
    banner?: HTMLElement
    message?: HTMLDivElement
    toggleMessage?: HTMLButtonElement

    constructor(banner: HTMLElement) {
        super()

        const toggle = banner.querySelector('.navigation-toggle')
        const toggleMessage = banner.querySelector('.banner-message-close')
        const message = banner.querySelector('.banner-message')

        banner && (this.banner = banner)
        toggle && (this.toggle = toggle as HTMLButtonElement)
        toggleMessage && (this.toggleMessage = toggleMessage as HTMLButtonElement)
        message && (this.message = message as HTMLDivElement)
    }

    start() {
        const cookieId = this.toggleMessage?.dataset.id
        const expression = cookieId && new RegExp(cookieId)

        this.ready()

        expression && !document.cookie.match(expression) && this.message && (this.message.style.display = 'block')

        this.toggle?.addEventListener('click', () => this.banner?.classList.toggle('navigation-visible'))

        this.toggleMessage?.addEventListener('click', () => {
            cookieId && (document.cookie = `${this.toggleMessage?.dataset.id}=1`)
            this.message?.remove()
        })
    }
}
